import { render, staticRenderFns } from "./FormDocNumber.vue?vue&type=template&id=840a22f0"
import script from "./FormDocNumber.vue?vue&type=script&lang=js"
export * from "./FormDocNumber.vue?vue&type=script&lang=js"
import style0 from "./FormDocNumber.vue?vue&type=style&index=0&id=840a22f0&prod&lang=css"
import style1 from "./FormDocNumber.vue?vue&type=style&index=1&id=840a22f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports